import React from 'react'

import './index.scss'
import VideoPlayer from '../../../components/VideoDetail/VideoPlayer'

export default () => {
    return (
        <div className="video-detail-left-video">
            <div className="video-detail-left-video-wrapper">
                <VideoPlayer />
            </div>
        </div>
    )
}
